import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "containedr" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "404", -1)

import Center from "@/components/Center.vue";

export default /*#__PURE__*/_defineComponent({
  __name: '404View',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Center, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("generic.pageNotFound")), 1)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})